export const readObject = (obj) => (
    Object.getOwnPropertyNames(obj).reduce((acc, key) => {
        acc[key] = obj[key];
        return acc;
    }, {})
);

export const arrayify = (input) => Array.isArray(input) ? input : [input];